module.exports = __webpack_public_path__ + "static/media/checkmark-circle-outline.00339446.svg";